import React from 'react';
import './NavBtns.css'
import NavLink from './NavLink';
import Button from './Button';
import ThemeBtn from './ThemeSwitcher';

const NavBtns = (props) => {
    return ( 
        <div className='NavBtns'>
            <NavLink NavLinkClass="NavLinkSelected" NavLinkText="Home"/>
            <NavLink NavLinkClass="NavLink" NavLinkText="About Us"/>
            <NavLink NavLinkClass="NavLink" NavLinkText="Vision"/>
            <NavLink NavLinkClass="NavLink" NavLinkText="Our Team"/>
            <NavLink NavLinkClass="NavLink" NavLinkText="FAQ"/>
            <Button BtnText="Get in Contact"/>
            <ThemeBtn />
        </div>
     );
}
 
export default NavBtns;